import React from 'react';
import ChatPanel from './panel';
import { ChatMessage } from '@/utils/types';
import { List } from 'immutable';

interface ChatBoard {
  name?: string
  messages: List<ChatMessage>
  value: string
  teacher?: boolean
  mute?: boolean
  roomCount?: number
  sendMessage: (evt: any) => void
  handleChange: (evt: any) => void
}

export default function ChatBoard (props: ChatBoard) {
  var isMobile = /Android|webOS|iPhone|iPad|BlackBerry/i.test(navigator.userAgent);
  isMobile = isMobile != null ? isMobile : false;
  // console.log("-----------isMobile:"+isMobile);
  return (
    <div className={`chat-board ${ isMobile ? 'ChatBoardMedia' :''}`} style={{maxWidth:(isMobile ? "100vw" : "280px")}}>
      {props.name ? <div className="chat-roomname" style={{maxWidth:(isMobile ? "100vw" : "280px"),width:(isMobile ? "100vw" : "96px")}}>{props.name}{props.roomCount ? `(${props.roomCount})` : null }</div> : null}
        <ChatPanel
          messages={props.messages}
          value={props.value}
          sendMessage={props.sendMessage}
          handleChange={props.handleChange}
          isRoomboardTo={true} />
    </div>
  )
}